import { FunctionComponent } from 'react'
import Header from './header'
import PrivateRoutes from 'private-routes'

const Layout: FunctionComponent<{ handleLogout: () => void }> = ({
  handleLogout,
}) => (
  <main style={{ backgroundColor: '#fbfbfb' }}>
    <Header logout={handleLogout} />
    <PrivateRoutes />
  </main>
)

export default Layout
